import * as React from 'react'
import { Flex } from '@dooer/react-ui-kit'
import { range } from 'lodash-es'
import { css } from 'glamor'
import styles from './styles'
import { handleSpecialCharacters } from '../../utils'

interface INumbersProps {
  onChange: (value: number) => void
  value?: number | null
  amount: number
  includeColors?: boolean
  labelGood?: string | null
  labelBad?: string | null
}

const Numbers: React.FC<INumbersProps> = ({ value, onChange, amount, includeColors, labelGood, labelBad }) => {
  return (
    <div>
      <Flex alignItems="center" flexDirection="row" justifyContent="space-between" style={styles.root}>
        {range(amount + 1).map(number => {
          const isSelected = value === number

          return (
            <span
              key={number}
              onClick={() => onChange(number)}
              onKeyDown={e => e.keyCode === 13 && onChange(number)}
              role="button"
              tabIndex={0}
              {...css(styles.number(isSelected, number, includeColors))}
            >
              {number}
            </span>
          )
        })}
      </Flex>
      {labelGood && labelBad && <Helper labelBad={labelBad} labelGood={labelGood} />}
    </div>
  )
}

interface IHelperProps {
  labelGood: string
  labelBad: string
}

const Helper: React.FC<IHelperProps> = ({ labelGood, labelBad }) => (
  <Flex alignItems="center" flexDirection="row" justifyContent="space-between" style={styles.helper}>
    <span>
      {handleSpecialCharacters(labelBad, 'special')} <i>{handleSpecialCharacters(labelBad, 'text')}</i>
    </span>
    <span>
      <i>{handleSpecialCharacters(labelGood, 'text')}</i> {handleSpecialCharacters(labelGood, 'special')}
    </span>
  </Flex>
)

export default Numbers
